import { $authHost } from '.';

export async function getBonuses() {
  const response = await $authHost.request({
    url: '/bonuses',
  });
  return response;
}
